import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import InMemoryStorage from './InMemoryStorage';
import SafeStorage from './SafeStorage';
// eslint-disable-next-line import/no-anonymous-default-export
var _default = /*#__PURE__*/function (_SafeStorage) {
  function _default(options) {
    _classCallCheck(this, _default);
    var storageToUse;
    try {
      storageToUse = window.sessionStorage || InMemoryStorage;
    } catch (err) {
      storageToUse = InMemoryStorage;
    }
    return _callSuper(this, _default, [storageToUse, options]);
  }
  _inherits(_default, _SafeStorage);
  return _createClass(_default);
}(SafeStorage);
export { _default as default };